"use client";

import React from "react";
import Image from "next/image";
import { Link } from "@/i18n/navigation";
import { useLocale } from "next-intl";

// Icons
import {
  MdArrowForward,
  MdSupportAgent,
  MdOutlineAddHome,
  MdOutlinePublic,
} from "react-icons/md";

import styles from "./cta-banner.module.css";

export default function CtaBanner() {
  const locale = useLocale();
  const isRTL = locale === "ar" || locale === "he";

  return (
    <section className={styles.section}>
      <div className={styles.bannerContainer}>
        {/* Left Side: Image & Hero Text */}
        <div className={styles.imageSide}>
          <Image
            src="/placeholder-images/city-living.png"
            alt="Interior design"
            fill
            sizes="(max-width: 1024px) 100vw, 40vw"
            className={styles.backgroundImage}
          />
          <div className={styles.imageOverlay}>
            <h2 className={styles.title}>
              Găsește casa perfectă sau
              <br />
              listează proprietatea ta
            </h2>
            <p className={styles.subtitle}>
              Echipa noastră te poate ajuta în fiecare
              <br />
              pas al procesului.
            </p>
          </div>
        </div>

        {/* Right Side: 3 Action Cards */}
        <div className={styles.actionsSide}>
          {/* Card 1 */}
          <div className={styles.actionCard}>
            <div className={styles.cardHeader}>
              <MdSupportAgent className={styles.cardIcon} />
              <h3 className={styles.cardTitle}>Contactează un agent</h3>
            </div>
            <p className={styles.cardDesc}>
              Vorbește cu un specialist.
              <br />
              Obține consultanță personalizată.
            </p>
            <Link href="/contact" className={styles.cardBtn}>
              Contactează acum
              <MdArrowForward className={styles.btnIcon} />
            </Link>
          </div>

          {/* Card 2 */}
          <div className={styles.actionCard}>
            <div className={styles.cardHeader}>
              <MdOutlineAddHome className={styles.cardIcon} />
              <h3 className={styles.cardTitle}>Listează proprietatea</h3>
            </div>
            <p className={styles.cardDesc}>
              Ajunge la mii de cumpărători.
              <br />
              Promovează-ți proprietatea eficient.
            </p>
            <Link href="/add-listing" className={styles.cardBtn}>
              Listează acum
              <MdArrowForward className={styles.btnIcon} />
            </Link>
          </div>

          {/* Card 3 */}
          <div className={styles.actionCard}>
            <div className={styles.cardHeader}>
              <MdOutlinePublic className={styles.cardIcon} />
              <h3 className={styles.cardTitle}>Explorează oferte globale</h3>
            </div>
            <p className={styles.cardDesc}>
              Descoperă mii de proprietăți.
              <br />
              Găsește casa visurilor tale oriunde.
            </p>
            <Link href="/search" className={styles.cardBtn}>
              Explorează acum
              <MdArrowForward className={styles.btnIcon} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
